import { gql } from "@apollo/client";
export const checkoutMultiAthletePayments = gql`
mutation purchaseMemorabiliaMultiWithCko($athleteUserIds:[String!]!,$newCardTokenId:String!,$paymentInfo:PaymentInfoInput!,$savedCardId:String!) {
    purchaseMemorabiliaMultiWithCko(athleteUserIds:$athleteUserIds,newCardTokenId:$newCardTokenId,paymentInfo:$paymentInfo,savedCardId:$savedCardId)
{status data}
}
`;
